import ObjectParser from '@/utils/objectParser';

export class CustomOptionsServiceBase {
  _createDefaultParser() {
    return new ObjectParser();
    // Example of adding custom parsers:
    // .addStringParser('test', {
    //   defaultValue: '',
    // })
  }

  getOptions(options = {}) {
    return this._createDefaultParser().parse(options);
  }
}
